import { Add } from "@mui/icons-material";
import { Box, Button, Toolbar, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { useState } from "react";
import { setActiveInactiveTag } from "../../apis/Tags";
import { FormDrawer } from "../../components/Form/FormDrawer";
import { EditTags } from "../../components/Tag/EditTags";
import TagsTable from "../../components/Tag/TagsTable";

const useStyles = makeStyles()((theme) => ({
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
}));

export const Tags = () => {
	const { classes } = useStyles();
	const [isEdit, setIsEdit] = useState(false);
	const [editOpen, setEditOpen] = useState(false);

	const [row, setRow] = useState({});
	const [loading] = useState(false);

	const handleAddRole = () => {
		setRow({ name: "", active: true });
		setEditOpen(true);
		setIsEdit(false);
	};

	const handleEditRole = (item) => {
		setRow(item);
		setEditOpen(true);
		setIsEdit(true);
	};

	const handleActive = async (list) => {
		const tagData = { ...list, active: !list.active };
		await setActiveInactiveTag(tagData);
	};

	const reloadTable = async () => { };

	return (
		<Box p={2}>
			<Toolbar>
				<Typography className={classes.title} variant="h4" noWrap>
					List Categories
				</Typography>
				<Button
					onClick={() => handleAddRole()}
					startIcon={<Add />}
					variant="contained"
					color="primary"
				>
					Add List Category
				</Button>
			</Toolbar>
			<Box sx={{ px: 3 }}>
				<TagsTable
					handleEdit={handleEditRole}
					handleActive={handleActive}
				/>
			</Box>
			<FormDrawer
				open={editOpen}
				setEditOpen={setEditOpen}
				loading={loading}
			>
				<EditTags
					edit={isEdit}
					setEditOpen={setEditOpen}
					row={row}
					setRow={setRow}
					setRows={reloadTable}
					handleClose={() => setEditOpen(false)}
				/>
			</FormDrawer>
		</Box>
	);
};
